export default __webpack_public_path__ + "static/meet-the-principal-sr-margaret-979ead7722b6992e51816e897fe78725.jpg";